import { graphql } from '~publish/gql'

import { useTypedMutation } from '../../hooks/useTypedMutation'

export const RequestPostApproval = graphql(/* GraphQL */ `
  mutation RequestPostApproval($id: PostId!) {
    requestPostApproval(input: { id: $id }) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          status
          dueAt
          externalLink
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useRequestPostApproval = () =>
  useTypedMutation(RequestPostApproval, (data) => data.requestPostApproval, {
    refetchQueries: ['GetPostList'],
    successTypename: 'PostActionSuccess',
  })
